// Version : 1.0.0
// Author : AGALYA

const NocPhotosActionType = {
	/** ***************** update Noc Photos Start ************************/
	UPDATE_NOC_PHOTOS_START: 'update_noc_photos_start',
	UPDATE_NOC_PHOTOS_SUCCESS: 'update_noc_photos_success',
	UPDATE_NOC_PHOTOS_FAILURE: 'update_noc_photos_failure',
	UPDATE_NOC_PHOTOS_RESPONSE_REST_START: 'update_noc_photos_response_reset_start',
	UPDATE_NOC_PHOTOS_RESPONSE_CHANGED: 'update_noc_photos_response_changed',
	/** ***************** update Noc Photos End ************************/
};

export default NocPhotosActionType;
